function countValue(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
}

// Generic interpreter for partial-success bulk responses (delete/restore/not-spam).
// `threadsKey` is the field the backend uses for the number of threads acted on
// (movedThreads | restoredThreads | updatedThreads). ok = at least one acted;
// partial = succeeded but some selected threads were stale/missing or not all acted.
export function getBulkActionResult(data, requestedCount = 0, threadsKey = 'movedThreads') {
  const actedThreads = countValue(data?.[threadsKey]);
  const requestedThreads = countValue(requestedCount);
  const missingThreadIds = Array.isArray(data?.missingThreadIds) ? data.missingThreadIds : [];
  const ok = actedThreads > 0;

  return {
    ok,
    partial: ok && (
      data?.partial === true ||
      missingThreadIds.length > 0 ||
      (requestedThreads > 0 && actedThreads !== requestedThreads)
    ),
    actedThreads,
    requestedThreads,
    missingThreadIds,
  };
}

export function getBulkPermanentDeleteResult(data, requestedCount = 0) {
  const deleted = countValue(data?.deleted);
  const deletedThreads = countValue(data?.deletedThreads);
  const requestedThreads = countValue(requestedCount);
  const missingThreadIds = Array.isArray(data?.missingThreadIds) ? data.missingThreadIds : [];
  const ok = deleted > 0 && deletedThreads > 0;

  return {
    ok,
    partial: ok && (
      data?.partial === true ||
      missingThreadIds.length > 0 ||
      (requestedThreads > 0 && deletedThreads !== requestedThreads)
    ),
    deleted,
    deletedThreads,
    requestedThreads,
    missingThreadIds,
  };
}
